// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"3cf33378","123":"51de8aaf","428":"5f17414b","489":"5e3da3f7","524":"172feb80","540":"09380f56","666":"5958ad70","717":"13db4d0c","873":"38a08771","934":"b71c7089"}[chunkId] + ".chunk.js";
};